import makeStyles from '@mui/styles/makeStyles';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ReactNode } from 'react';
import { SxProps } from '@mui/system/styleFunctionSx';
import { Theme } from '@mui/material/styles';

const useStyles = makeStyles(theme => ({
  headerStep: {
    color: '#ffffff',
    fontWeight: 800,
    fontSize: 16,
    letterSpacing: 1,
    textTransform: 'uppercase',
    borderRadius: 12,
  },
  headerLabel: {
    fontWeight: 1000,
    fontSize: 16,
    alignItems: 'center',
    alignContent: 'center',
    margin: theme.spacing(1),
  },
  planHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(1.5, 1),
  },
  mainCard: {
    borderRadius: 8,
    overflow: 'hidden',
    backgroundColor: '#ffffff',
  },
}));

export const Panel = (
  { id, step, headerLabel, headerRightItem, skipTransform, children, footer, sx, border }: {
    id: string;
    step?: number;
    headerLabel?: ReactNode;
    headerRightItem?: ReactNode;
    skipTransform?: boolean;
    children: ReactNode;
    footer?: ReactNode;
    sx?: SxProps<Theme>;
    border?: boolean;
  },
) => {
  const classes = useStyles();

  return (
    <Box
      id={`${id}-panel`}
      key={`${id}-panel`}
      height="95%"
      sx={sx ?? ({
        minWidth: 0,
        display: 'flex',
        flexDirection: 'column',
      })}
    >
      {/* Main card */}
      <Paper
        id={`${id}-main-card`}
        key={`${id}-main-card`}
        className={classes.mainCard}
        sx={{
          height: '100%',
          width: '100%',
          border: border ? '2px solid #5959EB' : 'none',
          boxShadow: border ? '0 0 0 4px rgba(91,95,199,0.09), 0 4px 20px rgba(91,95,199,0.10)' : 'none',
        }}
        elevation={0}
      >
        {headerLabel && (
          <Box
            id={`${id}-plan-header`}
            key={`${id}-plan-header`}
            className={classes.planHeader}
          >
            <Box
              id={`${id}-plan-header-labels`}
              key={`${id}-plan-header-labels`}
              display="flex"
              flexDirection="row"
              justifyContent="center"
              alignItems="center"
              alignContent="center"
              gap={0.5}
            >
              {step && (
                <Box
                  id={`${id}-plan-header-step-box`}
                  key={`${id}-plan-header-step-box`}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  alignContent="center"
                  px={1.5}
                  py={0.5}
                  bgcolor="#5959EB"
                  borderRadius={12}
                >
                  <Typography
                    id={`${id}-plan-header-step-label`}
                    className={classes.headerStep}
                    justifyContent="center"
                    alignItems="center"
                    alignContent="center"
                  >
                    {step}
                  </Typography>
                </Box>
              )}
              <Box
                id={`${id}-plan-header-label-box`}
                key={`${id}-plan-header-label-box`}
                display="flex"
                justifyContent="center"
                alignItems="center"
                alignContent="center"
                px={1}
              >
                <Typography
                  id={`${id}-plan-header-label`}
                  key={`${id}-plan-header-label`}
                  variant="h6"
                  className={classes.headerLabel}
                  sx={{
                    textTransform: skipTransform ? 'none' : 'uppercase',
                  }}
                >
                  {headerLabel}
                </Typography>
              </Box>
            </Box>
            {headerRightItem}
          </Box>
        )}
        {children}
      </Paper>

      {/* Footer */}
      {footer && (
        <Box
          id={`${id}-footer`}
          key={`${id}-footer`}
          mt={3}
        >
          {footer}
        </Box>
      )}
    </Box>
  );
};
